import { Box, Typography, CircularProgress } from '@mui/material'
import ChatInput from './ChatInput'

const Footer = ({ onSendMessage, disable }) => {

    return (
        <Box sx={{
            backgroundColor: 'white',
            borderRadius: '25px',
            padding: '8px',
            position: 'relative',
            boxShadow: '0 5px 5px rgba(255, 255, 255, 0.05)',
            border: '3px grey',
        }}>
            <ChatInput onSendMessage={onSendMessage} disable={disable} />

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    mt: 1,
                    minHeight: '24px',
                }}
            >
                {!disable && (
                    <Typography
                        variant="body2"
                        sx={{
                            color: "#666666",
                            textAlign: "center",
                            fontSize: '0.85rem'
                        }}
                    >
                        TDS can make mistakes. Check important info.
                    </Typography>
                )}
                {disable && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress size={20} sx={{ mr: 1 }} />
                        <Typography variant="body2" sx={{ color: "primary.main" }}>
                            TDS is processing your message...
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    )
}

export default Footer